import { render, staticRenderFns } from "./TheCheckboxGroup.vue?vue&type=template&id=a2cf430e&"
import script from "./TheCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./TheCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./TheCheckboxGroup.vue?vue&type=style&index=0&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports